import { KatButton, KatInput } from '@amzn/katal-react';
import React, { FC } from 'react';
import { UrlInputProps } from '.';
import styles from './UrlInput.module.css';

export const UrlInput: FC<UrlInputProps> = ({ url, onChange, onFetch, isValidUrl, isFetching }) => (
  <div className={styles.container} data-testid="url-input-container">
    <KatInput
      value={url}
      onChange={onChange}
      placeholder="Enter URL"
      type="url"
      onKeydown={(e: KatInput.KeydownEvent) => {
        // Safely check if key property exists before using it
        const key = 'key' in e ? e.key : undefined;
        if (key === 'Enter' && isValidUrl && !isFetching) {
          // Prevent form submission if component is within a form
          if ('preventDefault' in e) {
            e.preventDefault();
          }
          onFetch();
        }
      }}
      data-testid="url-input"
    />
    <KatButton
      onClick={onFetch}
      disabled={!isValidUrl || isFetching}
      label="Fetch"
      variant="primary"
      data-testid="fetch-button"
    />
  </div>
);
